import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 30px auto;
  align-self: center;
`;

export default Container;
